import { useState, useRef } from "react";
import HTMLFlipBook from "react-pageflip";
// import '../index.css'; // Keep if general page styling is needed
import "../../DocViewer/components/Modal.css"; // Keep if modal styling is needed
import { Document, Page, pdfjs } from "react-pdf";
import './Flipbook.css'; // Import a CSS file for styling

// Set the workerSrc for pdfjs (Updated for v4)
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

// Define desired dimensions for a SINGLE page
const PAGE_WIDTH = 400; // Adjust as needed
const PAGE_HEIGHT = 550; // Adjust as needed

function Flipbook({ filePath }) {
  const [numPages, setNumPages] = useState(null);
  const flipBookRef = useRef(null);
  const [currentPageNum, setCurrentPageNum] = useState(1); // Track current page

  // Callback function when the PDF is loaded successfully
  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  // Callback for page flips to update current page number
  const handleFlip = (e) => {
    setCurrentPageNum(e.data + 1); // Adjust based on how you want to display page numbers
  };

  // Function to generate the list of Page components
  const renderPages = () => {
    const pages = [];
    if (!numPages) {
      return pages;
    }
    for (let i = 1; i <= numPages; i++) {
      pages.push(
        <div key={`page_${i}`} className="flipbook-page-container">
          <Page
            width={PAGE_WIDTH}
            height={PAGE_HEIGHT}
            pageNumber={i}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            renderInteractiveForms={false}
            className="flipbook-react-pdf-page"
          />
          <div className="flipbook-page-number">{i}</div>
        </div>
      );
    }
    return pages;
  };

  return (
    <div className="flipbook-viewer-container">
      <Document
        file={filePath}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div className="loading-message">Loading PDF...</div>}
        error={<div className="error-message">Failed to load PDF. Please try again.</div>}
      >
        {numPages && (
          <div className="flipbook-wrapper">
            <HTMLFlipBook
              width={PAGE_WIDTH}
              height={PAGE_HEIGHT}
              size="stretch"
              minWidth={PAGE_WIDTH}
              maxWidth={PAGE_WIDTH}
              minHeight={PAGE_HEIGHT}
              maxHeight={PAGE_HEIGHT}
              flippingTime={1000}
              usePortrait={false}
              startZIndex={0}
              maxShadowOpacity={0.5}
              showCover={false}
              mobileScrollSupport={true}
              onFlip={handleFlip}
              ref={flipBookRef}
              className="actual-flipbook-component"
            >
              {renderPages()}
            </HTMLFlipBook>
          </div>
        )}
      </Document>

      {numPages && flipBookRef.current && (
        <div className="flipbook-controls">
          <button
             onClick={() => flipBookRef.current?.pageFlip()?.flipPrev()}
             disabled={currentPageNum <= 1}
          >
            Previous
          </button>
          <span>
            Page {currentPageNum} - {currentPageNum + 1 > numPages ? '' : currentPageNum + 1} of {numPages}
          </span>
          <button
             onClick={() => flipBookRef.current?.pageFlip()?.flipNext()}
             disabled={currentPageNum >= numPages - 1}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default Flipbook;